import { createRoot } from "react-dom/client";
import "./index.css";
import App from "./App";

const root = createRoot(document.getElementById("root"));
root.render(<App />);

if (module.hot) {
  module.hot.accept("./App", () => {
    const NextApp = require("./App").default;
    root.render(<NextApp />);
  });
}

// No service worker is registered. react-scripts 5 does not generate one, and
// the registration that used to live here pinned an unreplaceable Workbox
// worker on returning browsers. public/service-worker.js now exists solely to
// unregister it.
